import React from "react";
import Grid from "@material-ui/core/Grid";

import styles from "./size-info.module.scss";
import image from "../../../assets/images/size-info/summer_dress.png";

function SummerDress() {
  return (
    <Grid container className={styles.sizeInfo}>
      <Grid item xs={12}>
        <h2 className={styles.sizeInfoTitle}>
          Возьмите ваше любимое платье и проведите измерения:
        </h2>
      </Grid>
      <Grid item xs={12} md={4} className={styles.sizeInfoImage}>
        <img src={image} />
      </Grid>
      <Grid item xs={12} md={8}>
        <ol>
          <li>Измерьте длину спины по центру.</li>
          <li>
            Измерьте ширину плеч от шва до шва, как указано на рисунке в таблице
            размеров (d).
          </li>
          <li>Измерьте ширину пояса вашего платья.</li>
          <li>Измерьте ширину в бёдрах в самом широком месте платья.</li>
          <li>Измерьте ширину низа вашего платья.</li>
          <li>
            В нашей таблице размеров найдите показатели, которые наиболее точно
            соответствуют получившимся цифрам.
          </li>
        </ol>
      </Grid>
    </Grid>
  );
}

SummerDress.propTypes = {};

export default SummerDress;
